import { withVisitSettlementGuard } from '~libs.shared.visit-settlement';

import { useVisitSettlementDropdownOption } from './extensions/appointments/useVisitSettlementDropdownOption';
import { useVisitSettlementCalendarFluidTab } from './extensions/calendar/tab/useVisitSettlementCalendarFluidTab';
import { useVisitSettlementFormTab } from './extensions/visitForm/useVisitSettlementFormTab';
import { useMedicalServicesTab } from './extensions/visitHistory/tab/medicalServicesTab/useMedicalServicesTab';
import { MedicalServicesCounterResolver } from './shared/counterResolver/MedicalServicesCounterResolver';
import { VisitSettlementMedicalServicesUpdateEventInterceptor } from './shared/medicalServices/VisitSettlementMedicalServicesUpdateEventInterceptor';
import { translations } from './translations';
import { useVisitSettlementUpdateMedicalServicesCommand } from './shared/medicalServices/medicalServices.hooks';

export type { UseVisitSettlementDropdownOptionReturnFn } from './extensions/appointments/useVisitSettlementDropdownOption';
export type { VisitSettlementBean } from './visitSettlement.types';

export default {
   MedicalServicesCounterResolver: withVisitSettlementGuard(MedicalServicesCounterResolver),
   MedicalServicesUpdateEventInterceptor: withVisitSettlementGuard(
      VisitSettlementMedicalServicesUpdateEventInterceptor
   ),

   // Protected flags inside hooks
   useMedicalServicesTab: useMedicalServicesTab,
   useVisitSettlementCalendarFluidTab: useVisitSettlementCalendarFluidTab,
   useVisitSettlementDropdownOption: useVisitSettlementDropdownOption,
   useVisitSettlementFormTab: useVisitSettlementFormTab,
   useVisitSettlementUpdateMedicalServicesCommand: useVisitSettlementUpdateMedicalServicesCommand,
   // Static re-exports
   translations: translations,
};
